import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
const blocks = [{
  label: 'Define the opportunity',
  accent: 'text-forge-cyan',
  bar: 'bg-forge-cyan',
  items: ['Market and search research', 'Service, product, and location priorities', 'Page architecture and content plan', 'Conversion actions and measurement']
}, {
  label: 'Build and improve',
  accent: 'text-forge-orange',
  bar: 'bg-forge-orange',
  items: ['Technical and on-page SEO', 'Content and landing pages', 'Google Ads support', 'Conversion tracking and page refinement']
}, {
  label: 'Measure and recommend',
  accent: 'text-forge-green',
  bar: 'bg-forge-green',
  items: ['Visibility and qualified traffic', 'Calls, forms, quotes, bookings, and orders', 'Reporting that explains what changed', 'Clear priorities for the next work']
}];
export function AiSeoLanes() {
  return <section id="seo" className="relative overflow-hidden bg-navy-900 py-14 lg:py-20" data-id="element-20" data-mp="2tnedven93y6">
      <div className="absolute inset-0 bp opacity-60" aria-hidden="true" data-id="element-21" data-mp="7shv8rt1wifn" />

      <div className="relative mx-auto max-w-8xl px-5 sm:px-8 lg:px-10" data-id="element-22" data-mp="cki3r8n6sjnu">
        <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-23" data-mp="cmm45glvn0jd">
          <div className="min-w-0 lg:col-span-7" data-id="element-24" data-mp="hitbndtx8k3f">
            <p className="font-mono text-[11.5px] uppercase tracking-[0.18em] text-forge-cyan" data-id="element-25" data-mp="3g18bbryf34rn">
              SEO, content &amp; paid search
            </p>
            <h2 className="mt-3 font-display text-[1.7rem] font-extrabold leading-[1.12] tracking-[-0.02em] text-white sm:text-[2.1rem]" data-id="element-26" data-mp="3l0bipj1vdn2s">
              Build visibility around the way customers search and decide.
            </h2>
          </div>
          <p className="min-w-0 text-[14.5px] leading-relaxed text-mist-200 lg:col-span-5" data-id="element-27" data-mp="1597435gf4kyj">
            WebsiteForge identifies the markets and searches worth pursuing, builds the pages and campaigns needed to
            compete, and keeps improving them as real performance data comes in.
          </p>
        </div>

        <ol className="mt-10 grid gap-px overflow-hidden rounded-2xl bg-white/[0.08] sm:grid-cols-3" data-id="element-28" data-mp="31cv2j6rn457t">
          {blocks.map((block, i) => <motion.li key={block.label} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.4,
          delay: i * 0.07
        }} className="min-w-0 bg-navy-950/90 p-6" data-id="element-29" data-mp="3f9qqe5cjw17x" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-30" data-mp="2wcp8xl1t88n3">
                <span className={`h-6 w-[3px] rounded-full ${block.bar}`} aria-hidden="true" data-id="element-31" data-mp="2wea1j54kdhib" />
                <p className={`font-mono text-[11.5px] uppercase tracking-[0.14em] ${block.accent}`} data-id="element-32" data-mp="2rkpa5vxh7ls3">{block.label}</p>
              </div>
              <ul className="mt-4 space-y-2.5" data-id="element-33" data-mp="1yxl2tkawuvd5">
                {block.items.map(item => <li key={item} className="min-w-0 text-[13.5px] leading-snug text-mist-100" data-id="element-34" data-mp="efkdxrhhtymy">
                    {item}
                  </li>)}
              </ul>
            </motion.li>)}
        </ol>

        <div className="mt-5 flex max-w-3xl gap-4 rounded-2xl border border-white/10 bg-white/[0.03] px-5 py-5" data-id="element-35" data-mp="5fnjf98fa5jz">
          <span className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-white/[0.06]" data-id="element-36" data-mp="af0cibpw08v0">
            <SparklesIcon className="h-4 w-4 text-forge-cyan" aria-hidden="true" data-id="element-37" data-mp="y4kx0z1ove6e" />
          </span>
          <div className="min-w-0" data-id="element-38" data-mp="1243hjtplln8p">
            <p className="text-[14px] font-bold text-white" data-id="element-39" data-mp="1230slrbu5uvf">How AI helps our team</p>
            <p className="mt-1.5 text-[13.5px] leading-relaxed text-mist-300" data-id="element-40" data-mp="o53wsx57hsht">
              AI helps our experienced team research markets, audit sites, compare options, draft efficiently, and run more
              thorough QA. WebsiteForge sets the priorities, approves the work, and remains accountable.
            </p>
          </div>
        </div>
      </div>
    </section>;
}